import products from './products';
import taxons from './taxons';
import loader from './loader';
import order from './order';
import orderList from './order-list';
import countries from './countries';
import checkout from './checkout';
import placedOrder from './placed-order';
import user from './user';
import locale from './locale';
import navigation from './navigation';
import lineItem from './line-item';
import error from './error';
import stores from './stores';
import auth from './auth';
import zones from './zones';
import anonymousUser from './anonymous-user';
import cartState from './cart-state';
import backgroundDisabled from './background-disabled';
import municipalities from './municipalities';
import wallets from './wallets';

export default {
    addProducts: products.addProducts,
    appendProducts: products.appendProducts,
    addKatapulkNavigation: navigation.addKatapulkNavigation,
    addProduct: products.addProduct,
    addAllStoreProducts: products.addAllStoreProducts,
    addOrders: orderList.addOrders,
    addOrder: orderList.addOrder,
    fetchProducts: products.fetchProducts,
    fetchAllStoreProducts: products.fetchAllStoreProducts,
    addTaxons: taxons.addTaxons,
    displayLoader: loader.displayLoader,
    hideLoader: loader.hideLoader,
    addProductToCart: order.addProductToCart,
    addingProductToCart: order.addingProductToCart,
    addingProductToCartFix: order.addingProductToCartFix,
    removingProductToCart: order.removingProductToCart,
    emptyCart: order.emptyCart,
    emptyCurrentCart: order.emptyCurrentCart,
    clearOrder: order.clearOrder,
    updateConfigsActiveCart: cartState.updateConfigsActiveCart,
    setTimeMinutesLeft: cartState.setTimeMinutesLeft,
    setTimeSecondsLeft: cartState.setTimeSecondsLeft,
    setHasExtraTimeCheckout: cartState.setHasExtraTimeCheckout,
    fetchStores: stores.loadStores,
    fetchStorePayments: stores.loadStorePayments,
    getStoresByZone: stores.getStoresByZone,
    removeProductFromCart: order.removeProductFromCart,
    removeDataExtraFromCart: order.removeDataExtraFromCart,
    changeProductQuantityFromCart: order.changeProductQuantityFromCart,
    updateOrderInState: order.updateOrderInState,
    getById: order.getById,
    refreshOrder: order.refreshOrder,
    setIsFinalStepHappening: order.setIsFinalStepHappening,
    syncOrderFromStorage: order.syncOrderFromStorage,
    addShippingCountries: countries.addShippingCountries,
    addBillingCountries: countries.addBillingCountries,
    goToPrevStep: checkout.goToPrevStep,
    goToNextStep: checkout.goToNextStep,
    getRedsysInfo: checkout.getRedsysInfo,
    addPlacedOrder: placedOrder.addPlacedOrder,
    clearPlacedOrder: placedOrder.clearPlacedOrder,
    login: auth.login,
    logout: user.logout,
    authCheckState: auth.authCheckState,
    setLocale: locale.setLocale,
    addLineItem: lineItem.addLineItem,
    disablingAdd: lineItem.disablingAdd,
    doError: error.doError,
    setCurrentStore: stores.setCurrentStore,
    loadGroupedStores: stores.loadGroupedStores,
    setAvailableZones: zones.setAvailableZones,
    setCurrentZone: zones.setCurrentZone,
    setAvailableMunicipalities: municipalities.setAvailableMunicipalities,
    setCurrentMunicipality: municipalities.setCurrentMunicipality,
    setIsMunicipalityPromptModalOpen: municipalities.setIsMunicipalityPromptModalOpen,
    setAnonymousUserAgeValid: anonymousUser.setAnonymousUserAgeValid,
    setAgeValid: user.setAgeValid,
    addRedsysPaymentError: checkout.addRedsysPaymentError,
    setBackgroundDisabled: backgroundDisabled.setBackgroundDisabled,
    // wallets
    fetchWalletTransactions: wallets.fetchWalletTransactions,
    fetchWalletDetails: wallets.fetchWalletDetails,
    activeWallet: wallets.activeWallet,
    activateWallet: wallets.activateWallet,
    transferWalletFunds: wallets.transferWalletFunds,
};



/** WEBPACK FOOTER **
 ** ./src/actions/index.js
 **/